import makeContainer from 'core/display/simple/Container'
import makeGraphics from 'core/display/simple/Graphics'
import TextCreate from 'core/display/simple/Text'
import { enableDrag } from 'core/handlers/DragHandler'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { create } from 'utils/Object'

export default class BuyBetCarouse extends PIXI.Container{
  constructor(data) {
    super()
    this.data = data
    this.isMultiplier = !!data.isMultiplier
    this.bets = new makeContainer
    this.multiplier = game.models.SpinModel.get().buy[0] || 1
    this.mask = new makeGraphics({
      width: data.width,
      height: data.height,
    })
    this.mask.x = 0

    this.prev = Number.NaN
    this.click = false

    this.texts = game.models.BetModel.getList().map(this.makeData.bind(this)).map(this.createText.bind(this))

    this.texts.forEach(this.applyPosition.bind(this))

    this.bets.addChild(...this.texts)
    this.bets.addChild(new makeGraphics(create(data, { alpha: 0 })))

    this.addChild(this.bets, this.mask)

    signal.on('MODEL:BET',  () => {
      if (isNaN(this.prev)) {
        gsap.killTweensOf(this.bets)
        gsap.to(this.bets, 0.3, { x: -game.models.BetModel.getID() * data.width })
      }
    })

    enableDrag(this.bets, { start: this.start, move: this.move, stop: this.stop })
  }

  makeData(value) {
    const newValue = this.isMultiplier ? value * this.multiplier : value
    const caption = FormatService.currency(newValue, false)
    return create(this.data, { text: caption.length > 5 ? caption.slice(0, -3) : caption })
  }

  applyPosition(text, idx) {
    text.x = idx * this.data.width
    text.y = 0
  }

  createText(data){
    return new TextCreate(data)
  }

  start({ x }) {
    this.click = true
    this.prev = x
  }

  move({ x }) {
    this.click = this.click && Math.round(x) === Math.round(this.prev)
    this.bets.x += x - this.prev
    this.bets.x = this.bets.x > 0 ? 0 : this.bets.x < -game.models.BetModel.getMaxID() * this.data.width ? -game.models.BetModel.getMaxID() * this.data.width : this.bets.x
    this.prev = x
    game.models.BetModel.setID(Math.round(-this.bets.x / this.data.width))
  }

  stop(point) {
    this.prev = Number.NaN
    if (this.click) {
      point = self.toLocal(point)
      game.models.BetModel.setID(game.models.BetModel.getID() + (point.x < 0 ? -1 : point.x > this.data.width ? 1 : 0))
    }
    else {
      game.models.BetModel.setID(Math.round(-this.bets.x / this.data.width))
    }
    signal.dispatch('SOUND:carousel')
  }
}
